import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(private http: HttpClient) { }

  getAreas(producto){
    return this.http.get(`${environment.baseUrl}/general/getAreas.php?producto=${producto}`);
  }

  getBancos(): Observable<any>{
    return this.http.get(`${environment.baseUrl}/pago/getBancos.php`);
  }

  getTipoAreas(){
    return this.http.get(`${environment.baseUrl}/general/getTipoArea.php`);
  }

  getPaises(){
    return this.http.get(`${environment.baseUrl}/general/getPaises.php`);
  }

  getTipoSusc(){
    return this.http.get(`${environment.baseUrl}/general/getTipoSusc.php`);
  }

  getEstado(codpais){
    return this.http.get(`${environment.baseUrl}/general/getEstado.php?codpais=${codpais}`);
  }

  getCiudad(postdata){
    return this.http.post(`${environment.baseUrl}/general/getCiudad.php`,postdata);
  }

  getMunicipio(postdata){
    return this.http.post(`${environment.baseUrl}/general/getMunicipio.php`,postdata);
  }

  getOficinas(){
    return this.http.get(`${environment.baseUrl}/general/getOficinas.php`);
  }

  getProducto(area){
    return this.http.get(`${environment.baseUrl}/general/getProducto.php?area=${area}`);
  }

  getRamo(codpol){
    return this.http.get(`${environment.baseUrl}/general/getRamo.php?codpol=${codpol}`);
  }

  getMoneda(){
    return this.http.get(`${environment.baseUrl}/general/getMoneda.php`);
  }

  getApprov( estatus:boolean ) {

    console.log(estatus+' servicio');

        return of(estatus);

  }

  getProveedor(postdata){
    return this.http.post(`${environment.baseUrl}/general/getClinicas.php`,postdata);
  }

  getTriaje(postdata){
    return this.http.post(`${environment.baseUrl}/general/getTriaje.php`,postdata);
  }

  getListEstados(codpais){
    return this.http.get(`${environment.baseUrl}/general/getEstado.php?codpais=${codpais}`);
  }

  getListCiudadades(postdata){
    return this.http.post(`${environment.baseUrl}/general/getCiudad.php`,postdata);
  }
  getEjecutivos(ejecutivo){
    return this.http.get(`${environment.baseUrl}/reportes/GetCotizemRepInter.php?usuario=${ejecutivo}`);
  }


}
